var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A4AAC4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.334 6.295c1.247 0 2.263.973 2.263 2.166v9.372c0 1.194-1.016 2.167-2.263 2.167H2.264C1.016 20 0 19.027 0 17.833V8.461c0-1.193 1.016-2.166 2.264-2.166zm.496 4.695H1.768v6.848c0 .263.22.475.496.475h16.07c.275 0 .496-.217.496-.475V10.99zM5.946 15.31c.486 0 .884.38.884.845 0 .466-.398.846-.884.846H4.051c-.486 0-.884-.38-.884-.846 0-.465.398-.846.884-.846zm5.41-2.797c.492 0 .885.38.885.846 0 .465-.398.846-.884.846h-1.208c-.486 0-.884-.38-.884-.846 0-.465.398-.846.884-.846zm-4.045 0c.486 0 .884.38.884.846 0 .465-.398.846-.884.846h-3.29c-.486 0-.884-.38-.884-.846 0-.465.398-.846.884-.846zm11.023-4.526H2.264c-.275 0-.496.211-.496.474v.837H18.83v-.837c0-.263-.221-.474-.496-.474zM21.736 3C22.984 3 24 3.973 24 5.167v2.641c0 .465-.398.846-.884.846s-.884-.38-.884-.846V5.167c0-.263-.22-.475-.496-.475H5.666c-.486 0-.884-.38-.884-.846 0-.465.398-.846.884-.846z",
    transform: "translate(-40.000000, -216.000000) translate(0.000000, 200.000000) translate(40.000000, 16.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.c60a4437c609085161dc5d5f9769135c.svg";
export { ForwardRef as ReactComponent };